/**
 * Predictive Search — inline overlay with live AJAX results
 *
 * Uses Shopify Predictive Search API:
 *   GET /search/suggest.json?q=QUERY&resources[type]=product&resources[limit]=6
 */
(function() {
  'use strict';

  var overlay  = document.getElementById('search-overlay');
  var input    = overlay ? overlay.querySelector('[data-search-input]') : null;
  var resultsContainer = overlay ? overlay.querySelector('[data-search-results]') : null;
  var closeBtn = overlay ? overlay.querySelector('[data-search-close]') : null;

  if (!overlay || !input || !resultsContainer) return;

  var debounceTimer = null;
  var abortController = null;
  var lastQuery = '';

  /* ── Open / Close ── */

  function openSearch() {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-open');
    setTimeout(function() { input.focus(); }, 100);
  }

  function closeSearch() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-open');
    input.value = '';
    resultsContainer.innerHTML = '';
    lastQuery = '';
  }

  /* Bind all search triggers */
  document.querySelectorAll('[data-search-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      /* Close mobile menu if open */
      var mobileMenu = document.querySelector('.mobile-menu-overlay.open');
      if (mobileMenu) {
        mobileMenu.classList.remove('open');
        document.body.classList.remove('mobile-menu-open');
      }
      openSearch();
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      closeSearch();
    });
  }

  /* Close on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('open')) {
      closeSearch();
    }
  });

  /* Close when clicking overlay background */
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) {
      closeSearch();
    }
  });

  /* ── Predictive Search ── */

  function formatMoney(priceStr) {
    var num = parseFloat(priceStr);
    if (isNaN(num)) return '';
    var amount = num.toFixed(2).replace('.', ',');
    if (window.__shopMoney && window.__shopMoney.format) {
      return window.__shopMoney.format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
        .replace(/\{\{\s*amount\s*\}\}/, num.toFixed(2));
    }
    return amount + ' \u20AC';
  }

  function fetchResults(query) {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    var url = '/search/suggest.json?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[limit]=6'
      + '&resources[options][unavailable_products]=last';

    fetch(url, { signal: abortController.signal, credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        renderResults(data, query);
      })
      .catch(function(err) {
        if (err.name !== 'AbortError') {
          console.error('[predictive-search]', err);
        }
      });
  }

  function renderResults(data, query) {
    var products = data.resources && data.resources.results && data.resources.results.products
      ? data.resources.results.products
      : [];

    if (products.length === 0) {
      resultsContainer.innerHTML =
        '<div class="search-no-results">' +
          '<p>Keine Ergebnisse für „<strong>' + escapeHtml(query) + '</strong>"</p>' +
        '</div>';
      return;
    }

    var html = '<div class="search-results-grid">';

    products.forEach(function(product) {
      var imgSrc = product.image
        ? product.image.replace(/(\.\w+)(\?|$)/, '_300x$1$2')
        : '';
      var compareMax = parseFloat(product.compare_at_price_max) || 0;
      var priceMin = parseFloat(product.price_min || product.price) || 0;
      var priceMax = parseFloat(product.price_max || product.price) || 0;
      var hasDiscount = compareMax > priceMin;
      var price = hasDiscount ? formatMoney(String(priceMax)) : (product.price ? formatMoney(product.price) : '');
      var comparePrice = hasDiscount ? formatMoney(product.compare_at_price_max) : '';

      html += '<a href="' + product.url + '" class="search-result-item">';
      if (imgSrc) {
        html += '<div class="search-result-img">'
          + '<img src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" width="80" height="80" loading="lazy">'
          + '</div>';
      }
      html += '<div class="search-result-body">'
        + '<div class="search-result-title">' + escapeHtml(product.title) + '</div>';
      if (hasDiscount) {
        html += '<div class="search-result-price">'
          + '<span class="search-result-price--sale">' + price + '</span> '
          + '<small><s>' + comparePrice + '</s></small>'
          + '</div>';
      } else {
        html += '<div class="search-result-price">' + price + '</div>';
      }
      html += '</div></a>';
    });

    html += '</div>';
    html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="search-view-all">'
      + 'Alle Ergebnisse anzeigen →'
      + '</a>';

    resultsContainer.innerHTML = html;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ── Input Handler ── */

  input.addEventListener('input', function() {
    var query = input.value.trim();

    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      lastQuery = '';
      return;
    }

    if (query === lastQuery) return;
    lastQuery = query;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      fetchResults(query);
    }, 250);
  });

  /* Expose for external use */
  window.openSearch = openSearch;
  window.closeSearch = closeSearch;

})();
